import { Component, EventEmitter, Input, Output } from '@angular/core';
import { mapBrandLabel } from '../../../core/constants/brand-label';

@Component({
    selector: 'app-venue-details-dialog',
    templateUrl: './venue-details-dialog.component.html',
    styleUrls: ['./venue-details-dialog.component.scss'],
})
export class VenueDetailsDialogComponent {
    @Input() visible: boolean = false;
    @Input() header: string = 'Venue Details';
    @Input() venue: any | null = null;
    @Input() data: any | null = null;
    @Input() enableImageDownload: boolean = false;
    @Input() showLabels: boolean = true;
    @Input() sections: Array<{
        title: string;
        fields: Array<{
            label: string;
            path?: string;
            value?: any;
            pipe?: 'date' | 'datetime';
            type?: 'text' | 'image';
        }>;
    }> = [];

    @Output() visibleChange = new EventEmitter<boolean>();

    onHide(): void {
        this.visibleChange.emit(false);
    }

    formatList(value: any): string {
        if (!value) {
            return '-';
        }
        if (Array.isArray(value)) {
            return value.length ? mapBrandLabel(value.join(', ')) : '-';
        }
        return mapBrandLabel(String(value));
    }

    // Maps the under-the-hood venue category to its display name.
    // Stored values stay 'premium'/'champion'; only the face value changes.
    venueTypeLabel(value: any): string {
        if (value === null || value === undefined || value === '') {
            return '-';
        }
        return mapBrandLabel(String(value));
    }

    valueOrDash(value: any): string {
        if (value === null || value === undefined || value === '') {
            return '-';
        }
        return mapBrandLabel(String(value));
    }

    shouldShowField(field: {
        label: string;
        path?: string;
        value?: any;
        pipe?: 'date' | 'datetime';
        type?: 'text' | 'image';
    }): boolean {
        const label = field.label?.toLowerCase() ?? '';
        const path = field.path?.toLowerCase() ?? '';
        // Hide any field whose label or path contains "id"
        return !label.includes('id') && !path.includes('id');
    }

    getValueByPath(obj: any, path?: string): any {
        if (!obj || !path) {
            return undefined;
        }
        return path.split('.').reduce((acc: any, key: string) => {
            if (acc === null || acc === undefined) {
                return undefined;
            }
            return acc[key];
        }, obj);
    }

    getImageDownloadName(fieldLabel: string, imageUrl: string): string {
        const safeLabel = (fieldLabel || 'image')
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
        const extensionMatch = imageUrl?.split('?')[0]?.match(/\.[a-zA-Z0-9]+$/);
        const extension = extensionMatch ? extensionMatch[0] : '.jpg';
        return `${safeLabel || 'image'}${extension}`;
    }

    private getFilePath(url: string): string {
        return (url || '').split('?')[0].toLowerCase();
    }

    isImageUrl(url: string): boolean {
        const filePath = this.getFilePath(url);
        return /\.(jpg|jpeg|png|gif|webp|bmp|svg|avif)$/i.test(filePath);
    }

    isVideoUrl(url: string): boolean {
        const filePath = this.getFilePath(url);
        return /\.(mp4|webm|ogg|mov|m4v|avi|mkv)$/i.test(filePath);
    }
}
